import React from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { SnackbarProvider } from 'notistack'
import './App.css'
import ScrollToTop from './Components/Common/ScrollToTop'

import DashboardLoginPage from './Pages/DashBoard/DashboardLoginPage'
import MentalDashboardPage from './Pages/DashBoard/MentalDashboardPage'
import PatientInfoPage from './Pages/DashBoard/PatientInfoPage'
import Theme from './Components/Theme'

function App() {
  return (
    <div className="App">
      <SnackbarProvider maxSnack={3}>
        <BrowserRouter>
          <ScrollToTop />
          <Theme>
            <Routes>
              {/* Dashboard */}
              <Route
                path="/dashboard-login"
                element={<DashboardLoginPage />}
              />
              <Route
                path="/mental-dashboard"
                element={<MentalDashboardPage />}
              />
              <Route
                path="/patient-info"
                element={<PatientInfoPage />}
              />
              <Route
                path="*"
                element={<DashboardLoginPage />}
              />
            </Routes>
          </Theme>
        </BrowserRouter>
      </SnackbarProvider>
    </div>
  )
}

export default App
